import { useI18n } from 'vue-i18n'
import columnStore from '@/stores/column'

export default function useVulnerabilityColumns(component: string) {
	const i18n = useI18n()
	const cols = columnStore()

	const code = cols.define(component, 'code', i18n.t('vulnerability.code'), true)
	const name = cols.define(component, 'name', i18n.t('vulnerability.name'), true)
	const catalog = cols.define(component, 'catalog', i18n.t('vulnerability.catalog'), true)
	const connectedRisks = cols.define(component, 'connectedRisks', i18n.t('vulnerability.connectedRisks'), true)
	const score = cols.define(component, 'risk_score', i18n.t('vulnerability.score'), true)
	const category = cols.define(component, 'category', i18n.t('vulnerability.category'), true)
	const description = cols.define(component, 'description', i18n.t('vulnerability.description'), true)
	const comment = cols.define(component, 'comment', i18n.t('misc.comment'), true)
	const instance = cols.define(component, 'instance_id', i18n.t('instance'), true)

	const columns = {
		code,
		name,
		catalog,
		connectedRisks,
		score,
		category,
		description,
		comment,
		instance,
	}

	const { custom, all } = cols.finalize(component, columns)

	return { columns, custom, all }
}
